import React from 'react';

import { ServiceGroupSelect } from '@components';
import { L } from '@lib';
import { Button, Col, Row, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ServiceGroup } from '@services';

const { Text } = Typography;

interface IProps {
  serviceGroup?: ServiceGroup;
  categoryTitle?: string;
  required?: boolean;
  setShowServiceGroupForm: (value: boolean) => void;
  handleServiceGroupClear: () => void;
  handleServiceGroupSelect: (id: number) => void;
  handleServiceGroupDeselect: (id: number) => void;
}

export const ServiceGroupAddSelect: React.FC<IProps> = ({
  serviceGroup,
  required = false,
  categoryTitle = 'Service category',
  setShowServiceGroupForm,
  handleServiceGroupClear,
  handleServiceGroupSelect,
  handleServiceGroupDeselect,
}) => {
  return (
    <>
      <Row justify="space-between">
        <Col>
          {categoryTitle && (
            <Text>
              <Text strong style={{ color: '#ff4d4f' }}>
                *
              </Text>{' '}
              {L(categoryTitle)}
            </Text>
          )}
        </Col>
        <Col>
          <Button icon={<PlusOutlined />} type="link" onClick={() => setShowServiceGroupForm(true)}>
            New service category
          </Button>
        </Col>
      </Row>

      <ServiceGroupSelect
        value={serviceGroup?.id}
        defaultValue={serviceGroup && { value: serviceGroup?.id, label: serviceGroup?.name }}
        status={required ? 'error' : undefined}
        onSelect={handleServiceGroupSelect}
        onDeselect={handleServiceGroupDeselect}
        onClear={handleServiceGroupClear}
      />
      {required && <Text style={{ color: 'red' }}>{L('Required')}</Text>}
      <br />
      <br />
    </>
  );
};
